export enum LoadingTemplateType {
    TwoLineAvatarList,
    Card,
    OrdineDettaglio,
    LavorazioneDettaglio,
    CreaSpedizione,
    Consumi,
    DistintaDettaglio,
    ReintegroDettaglio,
    DataTable
}
